<!--

<script setup>
import { ref, inject } from "vue";
import router from "../../router";
import BackRoute from "../../components/backroute/BackRoute.vue";
import axios from "@/gateway/backendapi";
import OrganizationChart from "primevue/organizationchart";
const selection = ref({});
const data1 = ref({});
const branchChatDetail = ref([]);
const getAverageIncomeChart = ref([]);
const getAverageAttendanceItem = ref([]);
const averageIncomeChartResult = ref([]);
const mappedBranch = ref([]);
const primarycolor = inject("primarycolor");
const series = ref([]);
const loading = ref(false);
const networkError = ref(false);

const goBack = () => {
  router.go(-1);
};

const getFirtTimerSeris = () => {
  branchChatDetail.value.forEach((i) => {
    let serviceIndex = Object.keys(i).findIndex((i) => i === "name");
    let serviceValue = Object.values(i)[serviceIndex];

    series.value.unshift(serviceValue);
  });
};

const proceedToBranchHierachy = () => {
  router.push("/tenant/branch/initialhierachysetup");
};
const averageIncomeChart = (array, key) => {
  averageIncomeChartResult.value = [];
  let result = array.reduce((result, currentValue) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    );
    return result;
  }, []);
  for (const prop in result) {
    averageIncomeChartResult.value.push({
      name: prop,
      value: result[prop].length,
    });
  }
};
const getBranchChartDetail = async () => {
  try {
    const { data } = await axios.get(
      "api/Branching/GetBranchesLeanInformation"
    );
    branchChatDetail.value = data.returnObject;

    const ROOT_PARENT_ID = "00000000-0000-0000-0000-000000000000";

    const mappedBranch = branchChatDetail.value.map((item) => ({
      id: item.id,
      parentid: item.parentID,
      data: {
        name: item.name,
        avatar: item.logo,
        label: item,
      },
      styleClass: "p-person",
    }));

    // Unflatten
    const unflatten = (items, parent = { id: null }) => {
      return items
        .filter((item) => item.parentid === parent.id)
        .map((item) => ({
          ...item,
          children: unflatten(items, item),
        }));
    };

    const rootNode =
      branchChatDetail.value.find((i) => i.parentID === ROOT_PARENT_ID) ||
      branchChatDetail.value[0];

    const treeData = {
      key: "0",
      type: "person",
      styleClass: "p-hq",
      data: {
        label: rootNode,
        name: rootNode.name,
        avatar: rootNode.logo,
      },
      children: unflatten(mappedBranch, { id: rootNode.id }),
    };

    console.log("TREE DATA:", treeData);
    data1.value = treeData;
  } catch (error) {
    console.error("Error fetching branch chart details:", error);
  }
};
getBranchChartDetail();
const getBranchChartDetail = async () => {
  loading.value = true;

  try {
    let { data } = await axios.get("api/Branching/GetBranchesLeanInformation");
    console.log(data, "kkkk");
    branchChatDetail.value = data.returnObject;
    getAverageIncomeChart.value = data.returnObject.map((i) => ({
      name: i.name,
      value: i.currentYearAverageIncome,
    }));
    getAverageAttendanceItem.value = data.returnObject.map((i) => ({
      name: i.name,
      value: i.currentYearAverageAttendance,
    }));
    mappedBranch.value = branchChatDetail.value.map((i) => {
      return {
        mainID: i.id,
        data: { name: i.name, avatar: i.logo, label: "CEO" },
        parent: i.parentID,
        styleClass: "p-person",
      };
    });
    let matchedValues = [];

    const allIDs = mappedBranch.value.map((i) => i.mainID);
    let sum = 0;
    allIDs.forEach((i) => {
      mappedBranch.value.forEach((j, ind) => {
        if (i == j.parent) {
          j.id = ind;
          j.parentid = sum;
          matchedValues.push(j);
        }
      });
      sum++;
    });
    const unflatten = function (array, parent, tree) {
      tree = typeof tree !== "undefined" ? tree : [];
      parent = typeof parent !== "undefined" ? parent : { id: 0 };
      var children = _.filter(array, function (child) {
        return child.parentid == parent.id;
      });
      if (!_.isEmpty(children)) {
        if (parent.id == 0) {
          tree = children;
        } else {
          parent["children"] = children;
        }
        _.each(children, function (child) {
          unflatten(array, child);
        });
      }
      return tree;
    };
    let treeConstruted = unflatten(matchedValues);
    const HQ = branchChatDetail.value.find((i) =>
      i.parentID.includes("00000000-000")
    );
    const belowHQ = branchChatDetail.value[0];
    let treeData = {
      key: "0",
      type: "person",
      styleClass: "p-hq",
      data: {
        label: HQ ? HQ : belowHQ,
        name: HQ && HQ.name ? HQ.name : belowHQ.name,
        avatar: HQ && HQ.logo ? HQ.logo : belowHQ.logo,
      },
      children: treeConstruted,
    };
    data1.value = treeData;
    console.log(treeData, "sssdssdsdsd");
    getFirtTimerSeris();
    averageIncomeChart(data.returnObject, "currentYearAverageIncome");
    loading.value = false;
  } catch (error) {
    console.log(error, "sssddsd");
    loading.value = false;
    networkError.value = true;
    if (error.toString().toLowerCase().includes("network error")) {
      networkError.value = true;
    } else {
      networkError.value = false;
    }
  }
};
getBranchChartDetail();
</script>
OrgChartExample.vue -->

<template>
  <div class="container-wid mt-5" v-loading="loading">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex flex-column flex-sm-row justify-content-between">
          <div>
            <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
              Hierarchical Branching system
            </div>
            <BackRoute />
          </div>

          <div>
            <el-button
              :color="primarycolor"
              @click="proceedToBranchHierachy"
              round
              size="large"
              class="text-white"
              >Manage Hierarchy</el-button
            >
          </div>
        </div>
      </div>

      <div class="container-fluid mt-5">
        <div class="org-chart-wrapper pt-4" v-if="data1">
          <OrganizationChart
            :value="data1"
            :collapsible="true"
            class="responsive-org-chart"
            selectionMode="single"
            v-model:selectionKeys="selection"
            :expandedKeys="expandedKeys"
            @node-toggle="onNodeToggle"
          >
            <template #person="slotProps">
              <div class="node-content">
                <img
                  :src="
                    slotProps.node && slotProps.node.data
                      ? slotProps.node.data.label.pastorPictureUrl
                      : ''
                  "
                  width="32"
                />
                <div>
                  {{
                    slotProps.node && slotProps.node.data
                      ? slotProps.node.data.name
                      : ""
                  }}
                </div>
                <div class="s-13 d-flex justify-content-between">
                  <span class="text-dak">
                    {{
                      slotProps.node && slotProps.node.data
                        ? slotProps.node.data.pastorName
                        : ""
                    }}
                  </span>
                  <span class="text-dak">
                    {{
                      slotProps.node && slotProps.node.data
                        ? Math.abs(
                            slotProps.node.data.membershipSize
                          ).toLocaleString()
                        : ""
                    }}
                  </span>
                </div>
              </div>
            </template>

            <template #default="slotProps">
              <div class="w-100">
                <img
                  :src="
                    slotProps.node && slotProps.node.data
                      ? slotProps.node.data.label.pastorPictureUrl
                      : ''
                  "
                  width="32"
                />
                <div class="w-100">
                  {{
                    slotProps.node && slotProps.node.data
                      ? slotProps.node.data.name
                      : ""
                  }}
                </div>
                <div class="s-13 d-flex justify-content-between">
                  <span class="text-dak">
                    {{
                      slotProps.node && slotProps.node.data
                        ? slotProps.node.data.pastorName
                        : ""
                    }}
                  </span>
                  <span class="text-dak">
                    {{
                      slotProps.node && slotProps.node.data
                        ? Math.abs(
                            slotProps.node.data.membershipSize
                          ).toLocaleString()
                        : ""
                    }}
                  </span>
                </div>
              </div>
            </template>
          </OrganizationChart>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, inject } from "vue";
import axios from "@/gateway/backendapi";
import OrganizationChart from "primevue/organizationchart";
import router from "../../router";
import BackRoute from "../../components/backroute/BackRoute.vue";

const data1 = ref(null);
const selection = ref({});
const branchChatDetail = ref([]);
const loading = ref(false);
const expandedKeys = ref({});
const primarycolor = inject("primarycolor");

const proceedToBranchHierachy = () => {
  router.push("/tenant/branch/initialhierachysetup");
};

// Recursive function to build the tree
const unflatten = (items, parentId = null) => {
  return items
    .filter((i) => i.parentid === parentId)
    .map((i) => ({
      ...i,
      children: unflatten(items, i.id),
    }));
};

// Assign unique keys and populate expandedKeys
let nodeKeyCounter = 0;
const assignKeysAndExpand = (node) => {
  node.key = `${nodeKeyCounter++}`;
  expandedKeys.value[node.key] = true; // Expand all initially (optional)
  if (node.children?.length) {
    node.children.forEach(assignKeysAndExpand);
  }
};

// Handle node expand/collapse
const onNodeToggle = (event) => {
  expandedKeys.value = event.value;
};

// Fetch and build org chart data
const getBranchChartDetail = async () => {
  loading.value = true;
  try {
    const { data } = await axios.get(
      "api/Branching/GetBranchesLeanInformation"
    );
    branchChatDetail.value = data.returnObject;

    // Map raw data
    const nodes = branchChatDetail.value.map((item) => ({
      id: item.id,
      parentid: item.parentID,
      data: {
        name: item.name,
        avatar: item.pastorPictureUrl,
        // avatar: item.logo,
        label: item,
        pastorName: item.pastorName,
        pastorPicture: item.pastorPictureUrl,
        membershipSize: item.membershipSize,
      },
      styleClass: "p-person",
    }));

    // Find root node
    const rootNode =
      branchChatDetail.value.find((i) =>
        i.parentID?.includes("00000000-0000-0000-0000-000000000000")
      ) || branchChatDetail.value[0];

    // Final org chart structure
    const rootTree = {
      type: "person",
      styleClass: "p-hq",
      data: {
        name: rootNode.name,
        // avatar: rootNode.logo,
        avatar: rootNode.pastorPictureUrl,
        label: rootNode,
        pastorName: rootNode.pastorName,
        pastorPicture: rootNode.pastorPictureUrl,
        membershipSize: rootNode.membershipSize,
      },
      children: unflatten(nodes, rootNode.id),
    };

    assignKeysAndExpand(rootTree);
    data1.value = rootTree;
    loading.value = false;
  } catch (error) {
    console.error("Failed to load org chart:", error);
    loading.value = false;
  }
};

onMounted(() => {
  getBranchChartDetail();
});
</script>

<style scoped>
.org-chart-wrapper {
  overflow-x: auto;
  background: #f4f4f4;
}
.node-content {
  padding: 1rem;
  background: #f4f4f4;
  border-radius: 8px;
  border: 1px solid #ccc;
}
</style>
